module.exports = __webpack_public_path__ + "img/icon-header-login.56982ec9.svg";